import { render } from "./dumps.vue?vue&type=template&id=3db10952&scoped=true"
import script from "./dumps.vue?vue&type=script&lang=js"
export * from "./dumps.vue?vue&type=script&lang=js"

import "./dumps.vue?vue&type=style&index=0&id=3db10952&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db10952"]])

export default __exports__